import { useTranslation } from 'react-i18next';
import { formatDateLocale } from '@/helpers/dateHelper';
import { SupportedIsraeliIdChangeRequestDtoIn } from '@/models/in/SupportedIsraeliIdChangeRequestDtoIn';
import styles from './IsraeliIdChangeRequest.module.css';

const DOT: Record<SupportedIsraeliIdChangeRequestDtoIn['status'], string> = {
  Pending: styles.dotPending,
  Approved: styles.dotApproved,
  Rejected: styles.dotRejected,
  Cancelled: '',
};

/**
 * The supported's requests to correct its ID on the office's blade (HAT-1428): what was asked, by
 * whom, and what was decided - the record the queue's decided tabs used to keep, now on the
 * supported it belongs to.
 */
const IsraeliIdChangeRequestHistory = ({ requests }: { requests: SupportedIsraeliIdChangeRequestDtoIn[] }) => {
  const { t, i18n } = useTranslation();
  const prefix = 'israeliIdChangeRequests';

  return (
    <div className={styles.requests}>
      {requests.map((r) => (
        <div key={r.id} className={styles.request}>
          <div className={styles.requestHead}>
            <span className={styles.ids}>
              <bdi className={styles.oldId}>{r.currentIsraeliId}</bdi>
              <span className={styles.arrow} aria-hidden="true">←</span>
              <bdi className={styles.newId}>{r.requestedIsraeliId}</bdi>
            </span>
            <span className={styles.status}>
              <span className={`${styles.dot} ${DOT[r.status]}`} />
              {t(`${prefix}.status.${r.status}`)}
            </span>
          </div>
          <p className={styles.requestLine}>
            {t(`${prefix}.requestedBy`, {
              name: r.requestedByName || r.requestedByEmail || '-',
              fund: r.fundName ? `${r.fundName} (${r.fundId})` : r.fundId,
              date: formatDateLocale(r.requestedAt, i18n.language),
            })}
          </p>
          {r.reviewedAt && r.status !== 'Cancelled' && (
            <p className={styles.requestLine}>
              {t(`${prefix}.decidedBy`, {
                date: formatDateLocale(r.reviewedAt, i18n.language),
                email: r.reviewedByEmail ?? '-',
              })}
            </p>
          )}
          {r.note && (
            <p className={styles.requestReason}>
              <span className={styles.noteLabel}>{t(`${prefix}.coordinatorNote`)}</span> {r.note}
            </p>
          )}
          {r.rejectionReason && (
            <p className={styles.requestReason}>
              <span className={styles.noteLabel}>{t(`${prefix}.reasonLabel`)}</span> {r.rejectionReason}
            </p>
          )}
        </div>
      ))}
    </div>
  );
};

export default IsraeliIdChangeRequestHistory;
